// extracted by mini-css-extract-plugin
export default {"section":"Subsidiaries_section__Bk0b0","subsidiaries":"Subsidiaries_subsidiaries__wurNb","item":"Subsidiaries_item__TAznG","flipped":"Subsidiaries_flipped__+z1PT"};